export { default } from './TabNav';
export * from './models';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/TabNav/index.ts